export const VIP_PRICE_COINS = 200;
export const VIP_DURATION_HOURS = 24;
